import PropTypes from 'prop-types';
import React from 'react';

import { RadioStyled } from './TrlRadioButton.styles';

export const TrlRadioButton = (props) => {
  const { value, selectedValue } = props;

  return (
    <RadioStyled
      checked={selectedValue && selectedValue === value}
      {...props}
    />
  );
};

TrlRadioButton.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  handleChange: PropTypes.func,
};
